import { render, staticRenderFns } from "./AskAiSuggetionDropdown.vue?vue&type=template&id=6b6fbdf4&scoped=true"
import script from "./AskAiSuggetionDropdown.vue?vue&type=script&lang=js"
export * from "./AskAiSuggetionDropdown.vue?vue&type=script&lang=js"
import style0 from "./AskAiSuggetionDropdown.vue?vue&type=style&index=0&id=6b6fbdf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6fbdf4",
  null
  
)

export default component.exports